
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Logo1 from "./Logo1.vue";
import ContactsBlock from "./ContactsBlock.vue";
import SocialLinks from "./SocialLinks.vue";
import CallOrderForm from "./forms/CallOrderForm.vue";
import anime from "animejs";

@Component({
  components: {
    Logo1,
    ContactsBlock,
    SocialLinks,
    CallOrderForm
  }
})
export default class UI extends Vue {
  $refs!: {
    uiWrap: Element;
    contentPanel: HTMLElement;
    menu: HTMLElement;
    callOrderForm: HTMLElement;
  };

  menuItems = ['Грин Хиллс', 'Планировки', 'Визуализация', 'Преимущества', 'Фото и видео', 'Материалы', '3D панорамы', 'Расположение', 'Контакты'];
  menuMobileItems = ['Грин Хиллс', 'Планировки', 'Визуализация', 'Преимущества', 'Фото и видео', 'Расположение', 'Контакты'];
  headerIsTransparent = true;
  mobileMenuOpened = false;
  mobileContactsPanelOpened = false;

  // Ссылки на глобальное состояние
  @State(state => state.app.loadingScreenActive) loadingScreenActive!: number;
  @Getter('pageBehindAWindow') pageBehindAWindow!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  get menuItemsToShow() {
    return this.scrollingByScreens ? this.menuItems : this.menuMobileItems
  }


  // Запускаем анимацию на исчезновении экрана загрузки
  @Watch('loadingScreenActive')
  onLoadingScreenHide() {
  }


  mounted() {
    if (!this.scrollingByScreens) {
      window.addEventListener("scroll", () => {
        if (document.body.getBoundingClientRect().top > -100 && !this.headerIsTransparent) {
          this.headerIsTransparent = true;
        } else if (document.body.getBoundingClientRect().top < -100 && this.headerIsTransparent) {
          this.headerIsTransparent = false;
        }
      });
    }
  }


  openContacts() {
    this.mobileMenuOpened = true;
    this.activateCloseButton();
    this.showContentPanel();
    this.showCallOrderForm();
  }


  menuItemClick(number: number) {
    let screens = document.querySelectorAll<HTMLElement>(".object-page .screen-wrap");
    let transition = { value: -(window.document.body.getBoundingClientRect().top) };
    let newValue = screens[number - 1].offsetTop - 54;
    anime({
      targets: transition,
      value: (newValue < 0) ? 0 : newValue,
      update: () => {
        window.scroll(0, transition.value);
      },
      duration: 1500,
      easing: "easeOutQuad"
    });

    this.mobileMenuOpened = false;
    this.mobileContactsPanelOpened = false;
    this.deactivateCloseButton();
    this.hideContentPanel();
  }


  openMenu() {
    if (this.mobileContactsPanelOpened || this.mobileMenuOpened) {
      if (this.mobileMenuOpened) {
        this.hideMenu();
      }
      if (this.mobileContactsPanelOpened) {
        this.hideCallOrderForm();
      }
      setTimeout(() => {
        this.mobileMenuOpened = false;
        this.mobileContactsPanelOpened = false;
        this.deactivateCloseButton();
        this.hideContentPanel();
      }, 200);
      return;
    }

    this.mobileMenuOpened = true;
    this.activateCloseButton();
    this.showContentPanel();
    this.showMenu();
  }


  activateCloseButton() {
    let callButton = this.$refs.uiWrap.querySelector<HTMLElement>(".call-button")!;
    let menuButtonLines = this.$refs.uiWrap.querySelectorAll<HTMLElement>(".menu-button > div");

    anime({
      targets: callButton,
      opacity: 0,
      duration: 300,
      easing: "easeOutQuad"
    });

    callButton.style.pointerEvents = "none";

    let timeline = anime.timeline({ autoplay: true });
    timeline.add({ targets: menuButtonLines[0], translateY: 8, duration: 300, width: 30, easing: "easeOutQuad" }, 180);
    timeline.add({ targets: menuButtonLines[1], opacity: 0, duration: 100, easing: "easeOutQuad" }, 0);
    timeline.add({ targets: menuButtonLines[2], translateY: -8, duration: 300, width: 30, easing: "easeOutQuad" }, 180);

    timeline.add({ targets: menuButtonLines[0], rotate: 45, duration: 300, easing: "easeOutQuad" }, 480);
    timeline.add({ targets: menuButtonLines[2], rotate: -45, duration: 300, easing: "easeOutQuad" }, 480);
  }


  deactivateCloseButton() {
    let callButton = this.$refs.uiWrap.querySelector<HTMLElement>(".call-button")!;
    let menuButtonLines = this.$refs.uiWrap.querySelectorAll<HTMLElement>(".menu-button > div");

    anime({
      targets: callButton,
      opacity: 1,
      duration: 300,
      easing: "easeOutQuad"
    });

    callButton.style.pointerEvents = "all";

    let timeline = anime.timeline({ autoplay: true });
    timeline.add({ targets: menuButtonLines[0], rotate: 0, duration: 200, easing: "easeOutQuad" }, 0);
    timeline.add({ targets: menuButtonLines[2], rotate: 0, duration: 200, easing: "easeOutQuad" }, 0);

    timeline.add({ targets: menuButtonLines[0], translateY: 0, duration: 300, width: 25, easing: "easeOutQuad" }, 200);
    timeline.add({ targets: menuButtonLines[1], opacity: 1, duration: 100, easing: "easeOutQuad" }, 200);
    timeline.add({ targets: menuButtonLines[2], translateY: 0, duration: 300, width: 25, easing: "easeOutQuad" }, 200);
  }


  showContentPanel() {
    this.$refs.contentPanel.style.display = "block";
    anime({
      targets: this.$refs.contentPanel,
      opacity: 1,
      duration: 400,
      delay: 20,
      easing: "easeOutQuad"
    });
  }


  hideContentPanel() {
    anime({
      targets: this.$refs.contentPanel,
      opacity: 0,
      duration: 400,
      easing: "easeOutQuad",
      complete: () => {
        this.$refs.contentPanel.style.display = "none";
      }
    });
  }


  showMenu() {
    let menuItems = this.$refs.menu.querySelectorAll<HTMLElement>(".mobile-menu-item");

    this.$refs.callOrderForm.style.display = "none";
    anime({
      targets: menuItems,
      duration: 700,
      easing: "easeOutQuad",
      opacity: [0, 1],
      translateY: [50, 0],
      delay: (el: any, index: number) => {
        return index * 80
      }
    });

    this.$refs.menu.style.display = "block";
  }


  hideMenu() {
    let menuItems = this.$refs.menu.querySelectorAll<HTMLElement>(".mobile-menu-item");
    anime({
      targets: menuItems,
      duration: 200,
      easing: "easeOutQuad",
      opacity: [1, 0],
      translateY: [0, -50],
      delay: (el: any, index: number) => {
        return index * 40
      },
      complete: () => {
        this.$refs.menu.style.display = "none";
      }
    });
  }


  showCallOrderForm() {
    this.$refs.callOrderForm.style.display = "block";
  }

  hideCallOrderForm() {
    setTimeout(() => {
      this.$refs.callOrderForm.style.display = "none";
    }, 700);
  }
}
